import { supportRef as i, fillRef as l, useComposeRef as u } from "../../../rc-util/es/ref.mjs";
import * as o from "react";
var c = /* @__PURE__ */ o.forwardRef(function(a, t) {
  var e = a.children, r = a.getTriggerDOMNode, f = i(e), n = o.useCallback(function(s) {
    l(t, r ? r(s) : s);
  }, [r]), p = u(n, e.ref);
  return f ? /* @__PURE__ */ o.cloneElement(e, {
    ref: p
  }) : e;
});
process.env.NODE_ENV !== "production" && (c.displayName = "TriggerWrapper");
export {
  c as default
};
//# sourceMappingURL=TriggerWrapper.mjs.map
